import { useCallback, useEffect, useState } from "react";
import { adminApi } from "../../lib/api";

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const reload = useCallback(
    () => adminApi().get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => {}),
    [],
  );
  useEffect(() => { reload(); }, [reload]);

  return (
    <div className="mt-6 space-y-3" data-testid="admin-contacts-tab">
      {contacts.length === 0 && <p className="text-[#5C5555]">No messages yet.</p>}
      {contacts.map((c) => (
        <div key={c.id} className="bg-white border border-[#E5DBD8] p-4 text-sm">
          <p className="font-serif text-lg">{c.name}</p>
          <p className="text-xs text-[#5C5555]">{c.email} · {c.phone} · {new Date(c.created_at).toLocaleString()}</p>
          <p className="mt-2">{c.message}</p>
        </div>
      ))}
    </div>
  );
}
